module.exports = __webpack_public_path__ + "img/img_clients7.b05f06be.jpg";